import React from "react";
import { Tabs } from "antd";
import "./style.css";

/**
 * Chỉ thanh tab (nội dung từng tab render bên ngoài: tìm kiếm + bảng/biểu đồ).
 */
export default function ReportStatisticTabs({
  activeKey = "summary",
  onChange,
}) {
  return (
    <Tabs
      className="report-statistic-tabs report-statistic-tabs--bar-only"
      activeKey={activeKey}
      onChange={onChange}
      items={[
        { key: "summary", label: "Thống kê tổng hợp", children: <></> },
        { key: "cashflow", label: "Thống kê dòng tiền", children: <></> },
        { key: "chart", label: "Biểu đồ", children: <></> },
      ]}
    />
  );
}
